import { useContext, useEffect, useState } from 'react'
import { isSetAccessToken } from 'services/AccessToken'
import { getUser } from 'services/user_services/GetUser'
import { UserI } from 'types/UserI'

import PageContext from '../global_state/context/PageContext'
import { PageType } from '../types/PageI'
import Loader from './Loader'

import SCSS from '../assets/scss/Entrance.module.scss'
import APP_SCSS from '../assets/scss/App.module.scss'

import content from 'languages/EntrancePage.json'
import UserContext from 'global_state/context/UserContext'
import Title from './Title'
import { BiArrowBack } from 'react-icons/bi'


function EntrancePage() {
    const {dispatchUser} = useContext(UserContext)
    const {page, dispatchPage}  = useContext(PageContext)
    let language = page.settings.language
    
    const [get_user_response, setGetUserResponse] = useState<string | UserI>()
    const [loading, setLoading] = useState(true)

    const handleClick = (event, page) => {
        // console.log(page);
        
        dispatchPage({type: "render", payload: {page: page}})
    }

    useEffect(() => {
        const getUserResponse = async () => {
            setGetUserResponse(await getUser())
        };
        
        if (isSetAccessToken()) {
            getUserResponse()  
        }

        setLoading(false)

    }, [])

    useEffect(() => {
        // console.log("get_user_response");
        // console.log(get_user_response);

        if (typeof get_user_response === 'object') {
            dispatchUser({type: "get_user", payload: get_user_response})
            dispatchPage({type: "render", payload: {page: PageType.user_profile}})
        }
        
    }, [get_user_response, dispatchPage, dispatchUser])

    if (loading) {
        return (
            <Loader/>
        )
    }
    
    
    const renderBackArrowText = () => {
        return content[language].back_arrow
    }
    const setWindowLocation = (e) => {
        console.log(e);
        // console.log(window.history.state);
        
        let url = new URL(window.location.href);
        
        window.location.href = url.origin;
        // window.history.go(-2)
    }
    const renderArrow = () => {

        return (
            <div
                className={SCSS.arrow_back} 
                onClick={(e) => setWindowLocation(e)}>
                <span>{renderBackArrowText()}</span>
                <BiArrowBack/>
             </div>
        )
    }

    return (
        <div className={SCSS.entrance_page}>
            <div className={SCSS.title}>{renderArrow()}</div>

            <button className={[APP_SCSS.button, SCSS.log_in_button].join(" ")} onClick={(e) => handleClick(e, PageType.log_in_form)} type='button'>{content[language].log_in_into_account}</button>
            
            <button className={[APP_SCSS.button, SCSS.create_online_account].join(" ")} onClick={(e) => handleClick(e, PageType.create_online_account)} type='button'>{content[language].confirm_online_account}</button>
            <button className={[APP_SCSS.button, SCSS.create_account].join(" ")} onClick={(e) => handleClick(e, PageType.create_account)} type='button'>{content[language].new_registration}</button>
        </div>
        
    )
}

export default EntrancePage